import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface MessageIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const MessageIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: MessageIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M5.85775 21V21.4352L6.23369 21.216L10.2845 18.8536C10.8523 18.9477 11.4279 18.9952 12 18.9952C17.0682 18.9952 21.25 15.3819 21.25 10.8726C21.25 6.36329 17.0682 2.75 12 2.75C6.93175 2.75 2.75 6.3633 2.75 10.8727C2.75 13.2217 3.88302 15.4118 5.85775 16.9485V21ZM9.90102 17.0467L7.56824 18.4069V16.1548V16.0247L7.46161 15.95L7.19264 15.7617C7.19264 15.7617 7.19263 15.7617 7.19263 15.7617C5.44646 14.5392 4.46074 12.7547 4.46074 10.8726C4.46074 7.4063 7.8028 4.51845 12 4.51845C16.1973 4.51845 19.5393 7.40629 19.5392 10.8726C19.5392 14.3391 16.1972 17.2268 12 17.2268C11.4296 17.2268 10.8543 17.1704 10.2902 17.0596L10.2901 17.0595L10.075 17.0174L9.98249 16.9992L9.90102 17.0467Z"
                fill={color}
                stroke={color}
                strokeWidth={0.5}
            />
        </svg>
    )
}

export default MessageIcon
